import { type IconProps, HowItWorksIcon } from './HowItWorksIcon'

export const HIW2 = (props: IconProps) => (
  <HowItWorksIcon name='hiw2' {...props} />
)
